import { create } from "zustand";

interface ProgressState {
  byLesson: Record<
    string,
    { progress: number; score?: number; completed: boolean }
  >;
  setProgress: (lessonId: string, progress: number) => void;
  setScore: (lessonId: string, score: number) => void;
  setCompleted: (lessonId: string) => void;
}

export const useProgressStore = create<ProgressState>((set) => ({
  byLesson: {},
  setProgress: (lessonId, progress) =>
    set((s) => ({
      byLesson: {
        ...s.byLesson,
        [lessonId]: { ...s.byLesson[lessonId], progress, completed: false },
      },
    })),
  setScore: (lessonId, score) =>
    set((s) => ({
      byLesson: {
        ...s.byLesson,
        [lessonId]: {
          ...s.byLesson[lessonId],
          progress: s.byLesson[lessonId]?.progress ?? 0,
          score,
          completed: false,
        },
      },
    })),
  setCompleted: (lessonId) =>
    set((s) => ({
      byLesson: {
        ...s.byLesson,
        [lessonId]: { ...s.byLesson[lessonId], progress: 100, completed: true },
      },
    })),
}));
